import { store } from '../../vuex'

function constructSidebarEntryFromRoute(route, currentPath = '') {

    if (route.meta.permissions !== undefined
        && route.meta.permissions.length !== 0
        && !(store.getters['auth/userHasOnePermission'](route.meta.permissions))
    ) {
        return null;
    }

    let returnRoute = {
        title: route.meta.label,
        attributes: {
            'data-section': route.meta.label
        }
    };


    if (route.meta.hasOwnProperty('icon')) {
        returnRoute.icon = route.meta.icon;
    }

    if (route.meta.hasOwnProperty('hiddenFromMenu') && route.meta.hiddenFromMenu === true) {
        return null;
    }

    currentPath = currentPath + '/' + route.path;

    if (route.hasOwnProperty('children') && !route.meta.hasOwnProperty('hideChildren')) {
        returnRoute.child = [];
        route.children.forEach(function (childRoute) {
            let childMenuItem = constructSidebarEntryFromRoute(childRoute, currentPath);
            if (childMenuItem != null) {
                returnRoute.child.push(constructSidebarEntryFromRoute(childRoute, currentPath));
            }
        });
    } else if (route.meta.hasOwnProperty('sectionLink')) {
        returnRoute.href = prepareLink(currentPath + '/' + route.meta.sectionLink);
    } else {
        returnRoute.href = prepareLink(currentPath);
    }
    return returnRoute;
}

export default function constructSidebarEntriesFromRoutes(routes) {
    let returnRoutes = [];

    routes.forEach(function (route) {
        if (route.hasOwnProperty('meta') && !route.meta.hasOwnProperty('hiddenFromMenu')) {
            let menuItem = constructSidebarEntryFromRoute(route);
            if (menuItem !== null) {
                returnRoutes.push(constructSidebarEntryFromRoute(route));
            }
        }
    });

    return returnRoutes;
}

function prepareLink(link) {
    link = link.replace(/\/$/, '');
    link = link.replace(/^\/+/g, '');
    return '/' + link.replace('//','/');
}
